import axios from "axios";

const baseURL = `${process.env.TRANSVERSAL_COMMON_API}`;

const getMunicipalities = async (department_id: number ) => {
    return axios.get(`${baseURL}/api/v1/municipalities/${department_id}`, {});
};

const getAllMunicipalities = async () => {
    return axios.get(`${baseURL}/api/v1/municipalities/`);
}

const getAllDepartments = async () => {
   return axios.get(`${baseURL}/api/v1/departments/`);
}

export { getMunicipalities, getAllMunicipalities, getAllDepartments };
